// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__2QcB-","label":"Completed_label__2yX2x"};